import { markRaw } from 'vue';
import type { DiscoveredRouteModule } from '@/router/generator/types';
import AnalyticsHeader from '@/components/app/admin/analytics/header-components/AnalyticsHeader.vue';

const AdminAnalyticsView = () => import('@/views/admin/AnalyticsView.vue');
export const NAME_ADMIN_ANALYTICS = 'AdminAnalytics';
export const PATH_ADMIN_ANALYTICS = 'analytics';

export const route: DiscoveredRouteModule = {
  id: 'admin.analytics',
  scope: 'admin',
  moduleKey: 'analytics',
  name: NAME_ADMIN_ANALYTICS,
  path: PATH_ADMIN_ANALYTICS,
  component: AdminAnalyticsView,
  meta: { 
    requiresAdmin: true, 
    dataLoaders: ['project_document', 'features'],
    dynamicComponent: markRaw(AnalyticsHeader),
    dynamicComponentScale: 'scale-100'
  },
};
